<template>
	<header ref="headingImage" :class="type">
		<slot>
			<hero-image :item="headingImage" />
		</slot>
		<slot name="scroll" />
	</header>
</template>

<script setup>
defineProps({
	headingImage: {
		type: Object,
		default: () => ({
			imageWebp: '',
			image: '',
			imageAlt: '',
		}),
	},
	type: {
		type: String,
		default: 'small',
	},
});
</script>

<style lang="scss" scoped>
header {
	position: relative;
}

header::after {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgb(0 0 0 / 15%);
}

header.large {
	max-height: 100vh;
	overflow: hidden;
}

header.small {
	height: 70vh;
}

@media (max-width: 880px) {
	header.large {
		height: 80vh;
		min-height: 640px;

		iframe {
			width: 360% !important;
			height: 130% !important;
			margin-left: -130% !important;
			min-height: 640px !important;
		}

		> div,
		> div > div {
			min-height: 640px;
			width: 100%;
		}
	}

	header.small {
		height: 60vh;
	}
}

@media (max-width: 640px) {
	header.large {
		min-height: 520px;
		height: 74vh;

		iframe {
			min-height: 520px !important;
		}

		> div,
		> div > div {
			min-height: 520px;
		}
	}
}
</style>
